module.exports = __webpack_public_path__ + "assets/create-class.03b4c4e6.svg";